import { useSelector } from "react-redux";
import { useAppDispatch } from "../../../app/hooks";
import { useParams } from "react-router";
import { DptoInsUpdData } from "./DptoInsUpdData";
import { DptoInsUpdReview } from "./DptoInsUpdReview";
import { dptoInsert, dptoUpdate, dptoInsUpdSlice, selectDptoInsUpd } from "../../../redux/dpto/dptoInsUpdSlice";
import ObjectInsUpd from "../../../features/base/page/ObjectInsUpd";
import { schoolDptosSlice } from "../../../redux/school/schoolDptosSlice";
import { schoolSlice, selectSchool } from "../../../redux/school/schoolSlice";
import SchoolPageAvatar from "../../school/basics/SchoolPageAvatar";
import SchoolPageTitle from "../../school/basics/SchoolPageTitle";
import { dptoSlice, selectDpto } from "../../../redux/dpto/dptoSlice";
import DptoPageTitle from "../basics/DptoPageTitle";
import DptoPageAvatar from "../basics/DptoPageAvatar";
import PageAuthenticatedLoading from "../../../features/pages/PageAuthenticatedLoading";
import { routeDpto } from "../../../routes/dpto";
import { routeSchool } from "../../../routes/school";
import { ElementMissingContext } from "../../../features/base/ElementMissingContext";
import { TopBar } from "../../../features/top/TopBar";

export function DptoInsUpd() {
//   const user = useSelector(selectUser);
  const dispatch = useAppDispatch();
  const school = useSelector(selectSchool);
  const dptoInsUpd = useSelector(selectDptoInsUpd);
  const dpto = useSelector(selectDpto);
  const {schoolId, dptoId} = useParams();

  console.log(`DptoInsUpd: ${schoolId}/${dptoId}`);
  if(!schoolId) {
    return <ElementMissingContext />;
  }

  const editing = dptoId !== undefined;
  const breadcrumbTitle = editing ? "Editar Departamento" : "Novo Departamento";

  if(editing) {
    if(dptoInsUpd.dpto.schoolId === "" && dpto.selected) {
      const changing = {
        ...dpto.selected
      };
      dispatch(dptoInsUpdSlice.actions.set(changing));
    }
  } else {
    if(dptoInsUpd.dpto.schoolId === "") {
      const changing = {
        ...dptoInsUpd.dpto
      };
      changing.schoolId = `${schoolId}`;
      dispatch(dptoInsUpdSlice.actions.set(changing));
    }
  }

  const breadcrumbs = [
    { 
      label: school.selected?.name ? school.selected?.name : "Escola", 
      href: routeSchool(schoolId, "department")
    },
    { label: breadcrumbTitle },
  ];

  const steps = [
    {
      name: "Dados do Departamento",
      component: <DptoInsUpdData />,
      check: () => dptoInsUpd.dpto.name.length > 4,
    },
    {
      name: "Revisão",
      component: <DptoInsUpdReview />,
    }
  ];

  const title = (editing) ? <DptoPageTitle schoolId={schoolId} dptoId={dptoId} /> : <SchoolPageTitle schoolId={schoolId} />;
  const pageAvatar = (editing) ? <DptoPageAvatar /> : <SchoolPageAvatar />;

  const buildContent = () => 
    <ObjectInsUpd 
        name="departamento" 
        submit={() => 
          (editing)
          ? dispatch(dptoUpdate({dptoId: dptoId, dpto: dptoInsUpd.dpto}))
          : dispatch(dptoInsert({dpto: dptoInsUpd.dpto}))
        } 
        backTo={ (editing) ? routeDpto(schoolId, dptoId) :  routeSchool(schoolId, "department")}
        backCleanup={() => {
          dispatch(schoolDptosSlice.actions.clean());
          dispatch(dptoInsUpdSlice.actions.clean());
        }}
        state={dptoInsUpd.state} 
        steps={steps}
        edit={editing}
      />
    ;

  return <PageAuthenticatedLoading key="editUpdateDpto"
        topbar={ <TopBar title={title} pageAvatar={pageAvatar} breadcrumbs={breadcrumbs} /> }
        loading={{
        states: editing ? [school.state, dpto.state] : [school.state], 
        content: buildContent,
        error: "Erro ao carregar Departamento",
        retry: () => {
            dispatch(schoolSlice.actions.clean());
            dispatch(dptoSlice.actions.clean());
        }
        }}
    />;

}
